import { gql } from "@apollo/client";

export interface PagedResult<T> {
  pageInfo: {
    hasNextPage: boolean;
    endCursor: string;
  }
  totalCount: number
  edges: { node: T }[]
}


export const GET_TOKEN = gql`
  query GetToken($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      response,
      refresh,
      expireHours,
      userInfo{
        salesPersonGuid
        salesPersonName,
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles,
        tenantId,
        rolesGuids
        sessionGuid
      }
    }
  }
`
export const GET_SETTING = gql`
query GET_SETTING($key: String) {
  settings(where: { settingKey: {eq:$key}}) {
    edges {
      node {
        settingKey
        value
        settingId
        tenantId
        guid
      }
    }
  }
}
`
export const GET_REFRESHED_TOKEN = gql`
  query GetToken($refresh: String!) {
    refreshLogin(refresh: $refresh) {
      response,
      refresh,
      expireHours,
      userInfo{
        salesPersonGuid
        salesPersonName,
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles,
        tenantId
      }
    }
  }
`


export const GET_ACTUEL_NEWS = gql`
  query ($cursor: String, $todayDate: DateTime) {
    activities(
      after: $cursor
      where: {
        planDateTime: { lte: $todayDate }
        planEndDateTime: { gte: $todayDate }
        activityType: { guid: { eq: "3C2922FD-AD4C-4870-B737-69DD81F3F1E6" } }
        activityStatus: { isCompleted: { eq: true } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          planDateTime
          planEndDateTime
          createDateTime
          activityStatements {
            statementCode
            statementText
            value
            notes
          }
        }
      }
    }
  }
`

export const GET_HIERARCHY_LIST = gql`
    query($guid1:UUID!, $guid2: UUID!, $guid3: UUID!, $guid4: UUID! ){
      productHierarchies(
        where: {
          or: [
            { guid: { eq: $guid1 } }
            { guid: { eq: $guid2 } }
            { guid: { eq: $guid3 } }
            { guid: { eq: $guid4 } }
          ]
        }
      ) {
        edges {
          node {
            displayName
            productHierarchyCode
            guid
            rank
          documentRelations {
          rank
          document {
            documentTypeCode
            fileName
            originalFileName
            }
           }
          }
        }
      }
    }
`

export const GET_SUB_HIERARCHIES = gql`
 query ($cursor: String, $topHieGuid: UUID!) {
  productHierarchies(after: $cursor, where: { guid: { eq: $topHieGuid } }) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        displayName
        productHierarchyCode
        guid
        rank
        subProductHierarchies {
          displayName
          guid
          documentRelations {
            rank
            document {
              documentTypeCode
              fileName
              originalFileName
              
            }
            
          }
        }
        products {
          displayName
          sku
          guid
          documentRelations {
            rank
            document {
              documentTypeCode
              fileName
              originalFileName
            }
          }
        }
        productProductHierarchies {
          product {
            displayName
            sku
            guid
            documentRelations {
              rank
              document {
                documentTypeCode
                fileName
                originalFileName
              }
            }
          }
        }
      }
    }
  }
}`

export const GET_PRODUCT_DETAIL = gql`
query ($productGuid: UUID!) {
  products(where: { guid: { eq: $productGuid } }) {
    edges {
      node {
        displayName
        guid
        sku
        shortDescription
        detailedDescription
        productTags {
          tagText
        }
        documentRelations {
          guid
          rank
          document {
            documentTypeCode
            fileName
            originalFileName
            displayName
            documentId
          }
        }
      }
    }
  }
}`


export const SEARCH_PRODUCT = gql`
query  ($searchString: String!,$searchString2: String!) {
  products(
    where: {
      or: [
        { displayName: { contains: $searchString } }
        { sku: { contains: $searchString } }
        { productReference: { contains: $searchString } }
        { shortDescription: { contains: $searchString } }
        { detailedDescription: { contains: $searchString } }
       
        { displayName: { contains: $searchString2 } }
        { sku: { contains: $searchString2 } }
        { productReference: { contains: $searchString2 } }
        { shortDescription: { contains: $searchString2 } }
        { detailedDescription: { contains: $searchString2 } }
      ]
    }
  ) {
    edges {
      node {
        displayName
        guid
        sku
        shortDescription
        detailedDescription
        productProductHierarchies {
          productHierarchy {
            displayName
          }
        }
        productHierarchy {
          displayName
        }
        productTags {
          tagText
        }
        productImages {
          imageType
          imageFileName
          imageCode
          rank
        }
      }
    }
  }
}`



export const SEARCH_PRODUCTTAG = gql`
query ($searchString: String!,$searchString2: String!) {
  productTagList (where: { or: [{ tagText: { contains: $searchString } },{ tagText: { contains: $searchString2 } }] }) {
    edges {
      node {
        tagText
      }
    }
  }
}
`

export const SEARCH_PRODUCT_HIERARCHY = gql`
query ($searchString: String!,$searchString2: String!) {
  productHierarchies(where: { or: [{ displayName: { contains: $searchString } },{ displayName: { contains: $searchString2 } }] }) {
    edges {
      node {
        displayName
        guid
        parentHierarchy {
          displayName
        }
      }
    }
  }
}`


export const GET_PRODUCT_HIERARHCY_BY_DEPTH = gql`
   query($cursor: String){
      productHierarchies(after:$cursor,where: {depth:{eq:2},productHierarchyCode:{startsWith:"SP"}}) 
      {
      pageInfo {
        endCursor
        hasNextPage
      }
        edges {
          node {
            displayName
            productHierarchyCode
            guid
            rank
        documentRelations {
          rank
          document {
            documentTypeCode
            fileName
            originalFileName
            }
           }
          }
        }
      }
    }`



export const GET_PRODUCTS_BY_TAG = gql`
    query ($cursor: String,$tagText:String) {
      products(
        after: $cursor
        where: {
          or: [
            {
              productProductHierarchies: {
                some: {
                  productHierarchy: { productHierarchyCode: { startsWith: "SP" } }
                }
              }
            }
            { productHierarchy: { productHierarchyCode: { startsWith: "SP" } } }
          ]
          productTags: { some: { tagText: { eq: $tagText } } }
        }
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            guid
            projectId
            sku
            tenantId
            sku
            barcode
            displayName
            productProductHierarchies {
              productHierarchyId
              productHierarchy {
                guid
                displayName
                productHierarchyId
                productHierarchyCode
                depth
              }
            }
            productHierarchy {
              guid
              productHierarchyId
              productHierarchyCode
              displayName
              depth
            }
            productTags {
              tagText
            }
            documentRelations {
              rank
              document {
                documentTypeCode
                fileName
                originalFileName
              }
            }
          }
        }
      }
    }
    `




export const GET_PRODUCTS_BY_TAGTEXT = gql`
query($cursor:String, $tagText: String) {
  products(after:$cursor, where: { productTags: { some: { tagText: { eq: $tagText } } } }) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        displayName
        guid
        sku
        shortDescription
        detailedDescription
        documentRelations {
          rank
          document {
            documentTypeCode
            fileName
            originalFileName
          }
        }
      }
    }
  }
}
`






